export const ACCENTED_WORDS: { [key: string]: string } = {
  ababa: 'ababá',
  abaca: 'abacá',
  abaco: 'ábaco',
  abara: 'abará',
  abare: 'abaré',
  abato: 'ábato',
  abavo: 'abavô',
  abebe: 'abebé',
  abece: 'abecê',
  abede: 'abedê',
  abies: 'ábies',
  abiga: 'ábiga',
  aboco: 'aboço',
  abofe: 'abofé',
  absis: 'ábsis',
  abuxo: 'abuxó',
  acaca: 'acaçá',
  acaco: 'acaço',
  acacu: 'açacu',
  acaem: 'acaém',
  acais: 'açaís',
  acaja: 'acajá',
  acame: 'açame',
  acamo: 'açamo',
  acana: 'açanã',
  acapa: 'açapa',
  acape: 'açape',
  acapo: 'açapo',
  acara: 'acará',
  acaro: 'ácaro',
  acata: 'acatá',
  acaua: 'acauã',
  acave: 'ácave',
  acavo: 'ácavo',
  accao: 'acção',
  achem: 'achém',
  acida: 'ácida',
  acido: 'ácido',
  acies: 'ácies',
  acino: 'ácino',
  aclis: 'áclis',
  acoba: 'açoba',
  acobe: 'açobe',
  acobo: 'açobo',
  acoda: 'açoda',
  acodo: 'açodo',
  acoes: 'ações',
  acola: 'acolá',
  acona: 'aconá',
  acope: 'ácope',
  acopo: 'ácopo',
  acora: 'açora',
  acore: 'açore',
  acoro: 'ácoro',
  acreu: 'acréu',
  acroa: 'acroá',
  acron: 'ácron',
  actia: 'áctia',
  acuba: 'açubá',
  acude: 'açude',
  acula: 'açula',
  acule: 'açule',
  aculo: 'açulo',
  acuma: 'acumã',
  acumi: 'açumi',
  acure: 'acuré',
  adica: 'adiça',
  adion: 'adíon',
  adito: 'ádito',
  adixa: 'adixá',
  adoca: 'adoça',
  adoco: 'adoço',
  adoga: 'adogã',
  advem: 'advém',
  aecio: 'aécio',
  aerea: 'aérea',
  aereo: 'aéreo',
  afefe: 'afefé',
  afega: 'afegã',
  afodo: 'áfodo',
  afoxe: 'afoxé',
  afura: 'afurá',
  agace: 'agacé',
  agada: 'agadá',
  agamo: 'ágamo',
  agape: 'ágape',
  agare: 'agaré',
  agaro: 'ágaro',
  agata: 'ágata',
  agate: 'ágate',
  ageis: 'ágeis',
  ageno: 'ágeno',
  agino: 'ágino',
  agios: 'ágios',
  aglia: 'áglia',
  agogo: 'agogô',
  agono: 'ágono',
  agrao: 'agrão',
  agrem: 'agrém',
  agria: 'ágria',
  aguai: 'aguaí',
  aguam: 'águam',
  aguas: 'águas',
  aguca: 'aguça',
  aguco: 'aguço',
  aguem: 'águem',
  agues: 'águes',
  aguia: 'águia',
  aiaca: 'aiaçá',
  aioca: 'aiocá',
  airao: 'airão',
  aitao: 'aitão',
  aiuca: 'aiucá',
  aivao: 'aivão',
  ajabo: 'ajabó',
  ajara: 'ajará',
  ajare: 'ajaré',
  ajobo: 'ajobó',
  ajupa: 'ajupá',
  alaba: 'alabá',
  alabe: 'alabê',
  alafe: 'alafé',
  alala: 'alalá',
  alalo: 'álalo',
  alamo: 'álamo',
  alboi: 'albói',
  album: 'álbum',
  alcai: 'alçai',
  alcam: 'alçam',
  alcar: 'alçar',
  alcas: 'alças',
  alceu: 'alceu',
  alcou: 'alçou',
  alcuz: 'alçuz',
  aldea: 'aldeã',
  alema: 'alemã',
  alemo: 'álemo',
  alhia: 'álhia',
  alias: 'aliás',
  alibi: 'álibi',
  alica: 'álica',
  alife: 'álife',
  alode: 'alodê',
  aloes: 'aloés',
  alojo: 'alôjo',
  alpao: 'alpão',
  alpea: 'álpea',
  altea: 'alteá',
  alufa: 'alufá',
  aluia: 'aluía',
  aluja: 'alujá',
  alula: 'álula',
  alvao: 'alvão',
  alveo: 'álveo',
  amago: 'âmago',
  amala: 'amalá',
  amana: 'amaná',
  amapa: 'amapá',
  ambao: 'ambão',
  ambar: 'âmbar',
  ambua: 'ambuá',
  ambui: 'ambuí',
  ameca: 'ameça',
  amnio: 'âmnio',
  amore: 'amoré',
  anaca: 'anacã',
  anaiu: 'anaiú',
  anaja: 'anajá',
  anaje: 'anajé',
  anaos: 'anãos',
  anaue: 'anauê',
  anaza: 'anãza',
  anaze: 'anãze',
  anazo: 'anãzo',
  ancia: 'anciã',
  andre: 'andré',
  aneis: 'anéis',
  angau: 'angaú',
  aniao: 'anião',
  animo: 'ânimo',
  anion: 'ânion',
  anjao: 'anjão',
  anodo: 'ânodo',
  anoes: 'anões',
  ansia: 'ânsia',
  antao: 'antão',
  anuai: 'anuaí',
  anuia: 'anuía',
  anuja: 'anujá',
  anulo: 'ânulo',
  aonio: 'aônio',
  apapa: 'apapá',
  apiao: 'apião',
  apice: 'ápice',
  apios: 'ápios',
  apira: 'ápira',
  apiro: 'ápiro',
  apoca: 'ápoca',
  apode: 'ápode',
  apoem: 'apõem',
  apoes: 'apões',
  apoia: 'apóia',
  apora: 'aporá',
  aporo: 'áporo',
  apoto: 'ápoto',
  aprea: 'apreá',
  aquem: 'aquém',
  aqueo: 'áqueo',
  araba: 'arabá',
  arabe: 'árabe',
  araia: 'araiá',
  araio: 'araió',
  araiu: 'araiú',
  arama: 'aramá',
  arata: 'aratá',
  araue: 'araué',
  araxa: 'araxá',
  arcao: 'arção',
  arche: 'arché',
  arcio: 'árcio',
  ardea: 'árdea',
  ardua: 'árdua',
  arduo: 'árduo',
  areao: 'areão',
  areas: 'áreas',
  arede: 'aredê',
  arere: 'arerê',
  areus: 'aréus',
  argao: 'argão',
  argio: 'árgio',
  argon: 'árgon',
  arias: 'árias',
  aribe: 'aribé',
  arico: 'aricó',
  arida: 'árida',
  arido: 'árido',
  aries: 'áries',
  arima: 'arimã',
  arime: 'arimé',
  arina: 'ariná',
  arita: 'aritá',
  arjao: 'arjão',
  armao: 'armão',
  armeu: 'arméu',
  arnes: 'arnês',
  arpao: 'arpão',
  arpeu: 'arpéu',
  arrio: 'arrió',
  arrua: 'arruá',
  arsis: 'ársis',
  artao: 'artão',
  aruai: 'aruaí',
  arube: 'arubé',
  arula: 'árula',
  aruma: 'arumã',
  arura: 'arurá',
  asaro: 'ásaro',
  ascio: 'áscio',
  ascon: 'áscon',
  ascua: 'áscua',
  aspis: 'áspis',
  aster: 'áster',
  astur: 'ástur',
  ataco: 'átaco',
  atala: 'atalá',
  atare: 'atarê',
  atele: 'átele',
  atens: 'aténs',
  atera: 'aterá',
  atica: 'atiça',
  atico: 'atiço',
  aticu: 'atiçu',
  atila: 'átila',
  atimo: 'átimo',
  atipo: 'átipo',
  atoba: 'atobá',
  atois: 'atóis',
  atomo: 'átomo',
  atona: 'átona',
  atono: 'átono',
  atoto: 'atotô',
  atrai: 'atraí',
  atras: 'atrás',
  atrio: 'átrio',
  atuia: 'atuía',
  atura: 'aturá',
  auacu: 'auaçu',
  aucao: 'aução',
  audio: 'áudio',
  auiba: 'auíba',
  aurea: 'áurea',
  aureo: 'áureo',
  auste: 'aúste',
  avare: 'avaré',
  aveao: 'aveão',
  avela: 'avelã',
  avens: 'avéns',
  aviao: 'avião',
  avida: 'ávida',
  avido: 'ávido',
  avila: 'ávila',
  avira: 'avirá',
  axexe: 'axexê',
  axilo: 'áxilo',
  axone: 'áxone',
  axoxo: 'axoxô',
  azibo: 'azibó',
  azigo: 'ázigo',
  azimo: 'ázimo',
  babao: 'babão',
  babui: 'babuí',
  badem: 'badém',
  badur: 'bádur',
  baena: 'baenã',
  bafer: 'báfer',
  bafia: 'báfia',
  bagua: 'baguá',
  baiao: 'baião',
  baias: 'baiás',
  balao: 'balão',
  balca: 'balça',
  bambe: 'bambê',
  bambi: 'bâmbi',
  baniu: 'baniú',
  banta: 'bantá',
  banze: 'banzé',
  baoba: 'baobá',
  barao: 'barão',
  barau: 'baraú',
  barem: 'barém',
  baria: 'bária',
  bario: 'bário',
  basio: 'básio',
  basis: 'básis',
  basse: 'bassê',
  batao: 'batão',
  batis: 'bátis',
  baule: 'baúle',
  baume: 'baumê',
  bauna: 'baúna',
  beaba: 'beabá',
  bebes: 'bebês',
  becua: 'bécua',
  bedem: 'bedém',
  bedui: 'beduí',
  beica: 'beiça',
  beico: 'beiçó',
  belao: 'belão',
  belem: 'belém',
  belis: 'bélis',
  bembe: 'bembé',
  benca: 'bença',
  bende: 'bendé',
  berca: 'berça',
  berco: 'berço',
  bereu: 'beréu',
  beroe: 'beroé',
  beros: 'berós',
  berta: 'berta',
  betao: 'betão',
  betel: 'bétel',
  betis: 'bétis',
  bibio: 'bibió',
  bibla: 'biblá',
  biboi: 'bibói',
  bicao: 'bicão',
  bidao: 'bidão',
  biduo: 'bíduo',
  bigua: 'biguá',
  bijui: 'bijuí',
  bilho: 'bilhó',
  bilis: 'bílis',
  birma: 'birmã',
  bisao: 'bisão',
  biter: 'bíter',
  biura: 'biurá',
  bivio: 'bívio',
  blase: 'blasé',
  boaba: 'boabá',
  bobao: 'bobão',
  bocai: 'boçai',
  bocal: 'boçal',
  bocam: 'boçam',
  bocao: 'bocão',
  bocas: 'boças',
  bocio: 'bócio',
  bocou: 'boçou',
  bocue: 'bocué',
  bofia: 'bófia',
  boica: 'boiça',
  boico: 'boiço',
  boicu: 'boiçu',
  boime: 'boimé',
  bojui: 'bojuí',
  bolao: 'bolão',
  bolco: 'bolço',
  bolho: 'bolhó',
  bones: 'bonés',
  bongo: 'bongô',
  bonus: 'bônus',
  borax: 'bórax',
  bosao: 'bosão',
  botao: 'botão',
  bouca: 'bouça',
  bouco: 'bouço',
  braca: 'braça',
  braco: 'braço',
  breta: 'bretã',
  brion: 'bríon',
  bruaa: 'bruaá',
  bubao: 'bubão',
  bucal: 'buçal',
  bucle: 'buclê',
  bucui: 'bucuí',
  bufao: 'bufão',
  buiam: 'buíam',
  buido: 'buído',
  builo: 'buílo',
  buira: 'buíra',
  bujao: 'bujão',
  buque: 'buquê',
  burco: 'burço',
  buteo: 'búteo',
  butia: 'butiá',
  butua: 'bútua',
  buzio: 'búzio',
  caaco: 'caacó',
  caacu: 'caaçu',
  caaee: 'caaeé',
  cabau: 'cabaú',
  cabiu: 'cabiú',
  cacai: 'caçai',
  cacam: 'caçam',
  cacao: 'cação',
  cacar: 'caçar',
  cacas: 'caças',
  cacea: 'cácea',
  cache: 'cachê',
  cacoa: 'caçoa',
  cacoe: 'caçoe',
  cacoo: 'caçoo',
  cacou: 'caçou',
  cacua: 'caçuá',
  caete: 'caetê',
  cafes: 'cafés',
  cagao: 'cagão',
  cagoa: 'cagoã',
  caias: 'caías',
  caica: 'caiçá',
  caico: 'caíco',
  caicu: 'caiçu',
  caida: 'caída',
  caido: 'caído',
  caira: 'caíra',
  caire: 'cairé',
  caite: 'caité',
  caiva: 'caíva',
  cajao: 'cajão',
  cajas: 'cajás',
  cajua: 'cajuá',
  cajui: 'cajuí',
  calao: 'calão',
  calca: 'calça',
  calco: 'calço',
  calix: 'cálix',
  camaa: 'camaá',
  camao: 'camão',
  camba: 'cambá',
  camia: 'camiã',
  camua: 'camuá',
  canca: 'cancã',
  candi: 'cândi',
  cangi: 'cângi',
  canoe: 'canoé',
  canon: 'cânon',
  canza: 'canzá',
  capao: 'capão',
  capea: 'cápea',
  capia: 'capiá',
  caraa: 'caraá',
  carao: 'carão',
  carda: 'cardã',
  careu: 'caréu',
  carie: 'cárie',
  carii: 'carií',
  cario: 'carió',
  cariu: 'cariú',
  carla: 'carla',
  caroa: 'caroá',
  caroe: 'caroé',
  carre: 'carrê',
  carua: 'caruá',
  carus: 'cárus',
  casao: 'casão',
  casba: 'casbá',
  catao: 'catão',
  catia: 'cátia',
  catua: 'catuá',
  cauba: 'caúba',
  cauma: 'caumã',
  cauna: 'caúna',
  cauno: 'caúno',
  caure: 'cauré',
  cavao: 'cavão',
  cavea: 'cávea',
  cavia: 'cávia',
  cebus: 'cébus',
  cecao: 'ceção',
  cecem: 'cecém',
  cecum: 'cécum',
  cedem: 'cedém',
  celia: 'célia',
  ceomo: 'céomo',
  cerea: 'cérea',
  cereo: 'céreo',
  ceria: 'céria',
  cerio: 'cério',
  cesao: 'cesão',
  cesar: 'césar',
  cesio: 'césio',
  cevao: 'cevão',
  chabo: 'chabó',
  chaca: 'chaça',
  chaco: 'chaço',
  chaem: 'chaém',
  chaja: 'chajá',
  chaos: 'chãos',
  chate: 'chaté',
  chaua: 'chauá',
  chebe: 'chebê',
  chiao: 'chião',
  chibe: 'chibé',
  chito: 'chitó',
  choca: 'choça',
  chogo: 'chogó',
  chuco: 'chuço',
  chues: 'chués',
  chule: 'chulé',
  ciamo: 'cíamo',
  ciato: 'cíato',
  cidao: 'cidão',
  cidro: 'cidró',
  cilio: 'cílio',
  cim90: 'cim90',
  cimao: 'cimão',
  cipos: 'cipós',
  ciria: 'círia',
  cirio: 'círio',
  cisao: 'cisão',
  cisio: 'císio',
  ciume: 'ciúme',
  ciuro: 'ciúro',
  civel: 'cível',
  coana: 'cóana',
  coano: 'cóano',
  cobio: 'cóbio',
  cocai: 'coçai',
  cocam: 'coçam',
  cocao: 'cocão',
  cocar: 'coçar',
  cocas: 'coças',
  codao: 'códão',
  codea: 'côdea',
  codeo: 'códeo',
  codex: 'códex',
  codio: 'códio',
  codon: 'códon',
  cofea: 'cófea',
  cogia: 'cógia',
  coiba: 'coíba',
  coibe: 'coíbe',
  coibo: 'coíbo',
  coleo: 'cóleo',
  colio: 'cólio',
  colon: 'cólon',
  comao: 'comão',
  conga: 'congá',
  copia: 'cópia',
  corao: 'corão',
  coras: 'corás',
  corba: 'corbã',
  corca: 'corça',
  corco: 'corço',
  corio: 'cório',
  corre: 'corré',
  corte: 'côrte',
  cotao: 'cotão',
  couca: 'couça',
  coupe: 'coupé',
  covao: 'covão',
  covoa: 'covoá',
  coxao: 'coxão',
  crapo: 'crapô',
  craua: 'crauá',
  creem: 'crêem',
  creie: 'creié',
  croca: 'croça',
  cuata: 'cuatá',
  cubie: 'cubié',
  cubio: 'cúbio',
  cubiu: 'cubiú',
  cuche: 'cuchê',
  cucio: 'cúcio',
  cufea: 'cúfea',
  cufia: 'cúfia',
  cuiao: 'cuião',
  cuica: 'cuíca',
  cuipe: 'cuipé',
  cuira: 'cuíra',
  cuita: 'cuitá',
  cuite: 'cuité',
  cuito: 'cuitó',
  culex: 'cúlex',
  cumai: 'cumaí',
  cumel: 'cúmel',
  cumis: 'cúmis',
  cuneo: 'cúneo',
  cunia: 'cúnia',
  cupai: 'cupaí',
  cupao: 'cupão',
  cupia: 'cupiá',
  curao: 'curão',
  curia: 'cúria',
  curio: 'curió',
  curua: 'curuá',
  cuter: 'cúter',
  cutis: 'cútis',
  cuxiu: 'cuxiú',
  dacao: 'dação',
  dacio: 'dácio',
  daiao: 'daião',
  dalem: 'dalém',
  dalia: 'dália',
  damao: 'damão',
  damar: 'dâmar',
  danca: 'dança',
  danco: 'danço',
  dandi: 'dândi',
  danes: 'danês',
  danio: 'dânio',
  darao: 'darão',
  daras: 'darás',
  darci: 'darci',
  dario: 'dario',
  debil: 'débil',
  decai: 'decaí',
  dedao: 'dedão',
  dedeu: 'dedéu',
  delio: 'délio',
  demao: 'demão',
  dende: 'dendê',
  denis: 'denis',
  depoe: 'depõe',
  depos: 'depôs',
  depre: 'deprê',
  derbi: 'dérbi',
  desca: 'desça',
  desco: 'desço',
  detem: 'detém',
  devio: 'dévio',
  diada: 'díada',
  diade: 'díade',
  diana: 'diana',
  dicao: 'dição',
  didia: 'dídia',
  diese: 'díese',
  dinio: 'dínio',
  diope: 'díope',
  dirao: 'dirão',
  diras: 'dirás',
  direm: 'dirém',
  dirra: 'dirrã',
  diula: 'diúla',
  dixis: 'díxis',
  docai: 'doçai',
  docal: 'doçal',
  docam: 'doçam',
  docar: 'doçar',
  docil: 'dócil',
  docou: 'doçou',
  dodoi: 'dodói',
  doiam: 'doíam',
  doias: 'doías',
  dolar: 'dólar',
  dolma: 'dólmã',
  doria: 'dória',
  dorio: 'dório',
  doris: 'dóris',
  dozao: 'dozão',
  drica: 'driça',
  dubia: 'dúbia',
  dubio: 'dúbio',
  duble: 'dublê',
  ducao: 'ducão',
  dugao: 'dugão',
  duita: 'duíta',
  dunia: 'dúnia',
  durao: 'durão',
  durga: 'durgá',
  durio: 'dúrio',
  duzia: 'dúzia',
  ebano: 'ébano',
  ebeno: 'ébeno',
  ebrio: 'ébrio',
  ebulo: 'ébulo',
  ecano: 'écano',
  ecope: 'écope',
  ecran: 'écran',
  ecras: 'ecrãs',
  ecula: 'écula',
  eculo: 'éculo',
  edere: 'ederé',
  edgar: 'edgar',
  edico: 'édico',
  edipo: 'édipo',
  edite: 'edite',
  edito: 'édito',
  efeta: 'éfeta',
  efifa: 'efifá',
  efode: 'éfode',
  efodo: 'éfodo',
  eforo: 'éforo',
  egide: 'égide',
  egipa: 'egipã',
  egito: 'egito',
  egrio: 'égrio',
  eguas: 'éguas',
  eicar: 'eiçar',
  eider: 'êider',
  eiros: 'eirós',
  elafa: 'elafá',
  elafo: 'élafo',
  elate: 'élate',
  eleda: 'eledá',
  elede: 'eledê',
  eleis: 'eléis',
  elepe: 'elepê',
  eluia: 'eluía',
  emaca: 'emaça',
  emaco: 'emaço',
  embai: 'embaí',
  embia: 'embiá',
  embiu: 'embiú',
  emboa: 'emboá',
  embui: 'embuí',
  emera: 'êmera',
  emero: 'êmero',
  emese: 'êmese',
  emico: 'êmico',
  empos: 'empós',
  emulo: 'êmulo',
  enase: 'ênase',
  entao: 'então',
  enula: 'énula',
  enves: 'envés',
  enxos: 'enxós',
  enxui: 'enxuí',
  enzoi: 'enzói',
  eoipo: 'eoípo',
  eolia: 'eólia',
  eolio: 'eólio',
  eones: 'éones',
  epica: 'épica',
  epico: 'épico',
  epoca: 'época',
  epoxi: 'epóxi',
  epura: 'épura',
  equio: 'équio',
  erama: 'eramá',
  erbio: 'érbio',
  erebo: 'érebo',
  ereis: 'éreis',
  ergio: 'érgio',
  erica: 'érica',
  erice: 'érice',
  erico: 'eriço',
  erina: 'érina',
  ervao: 'ervão',
  esere: 'eserê',
  esipo: 'ésipo',
  esoce: 'ésoce',
  espos: 'espós',
  estao: 'estão',
  estas: 'estás',
  ester: 'éster',
  esula: 'ésula',
  esvao: 'esvão',
  etego: 'étego',
  etica: 'ética',
  etico: 'ético',
  etigo: 'étigo',
  etimo: 'étimo',
  evano: 'évano',
  evase: 'evasê',
  exito: 'êxito',
  exodo: 'êxodo',
  expoe: 'expõe',
  expos: 'expôs',
  exule: 'êxule',
  fabio: 'fábio',
  facam: 'façam',
  facao: 'fação',
  facas: 'faças',
  facil: 'fácil',
  faiao: 'faião',
  falum: 'fálum',
  falus: 'fálus',
  fanao: 'fanão',
  fanio: 'fânio',
  fanti: 'fânti',
  farao: 'farão',
  fasia: 'fásia',
  fatao: 'fatão',
  fatua: 'fátua',
  fatuo: 'fátuo',
  faula: 'faúla',
  fecio: 'fécio',
  feiao: 'feião',
  feleo: 'féleo',
  felis: 'félis',
  felix: 'félix',
  femea: 'fêmea',
  femeo: 'fêmeo',
  femur: 'fêmur',
  fenix: 'fênix',
  feofo: 'feofó',
  feria: 'féria',
  fetao: 'fêtão',
  fiala: 'fíala',
  ficao: 'ficão',
  ficeo: 'fíceo',
  ficis: 'fícis',
  ficus: 'fícus',
  fideu: 'fidéu',
  fidia: 'fídia',
  fieis: 'fiéis',
  fifia: 'fífia',
  filao: 'filão',
  filer: 'fíler',
  fines: 'finês',
  fiofo: 'fiofó',
  fitao: 'fitão',
  fiusa: 'fiúsa',
  fiuza: 'fiúza',
  flozo: 'flozô',
  fluia: 'fluía',
  fluor: 'flúor',
  focao: 'foção',
  focio: 'fócio',
  fofao: 'fofão',
  fogao: 'fogão',
  foica: 'foiça',
  foico: 'foiço',
  folao: 'folão',
  folio: 'fólio',
  folis: 'fólis',
  fonon: 'fônon',
  forca: 'força',
  forum: 'fórum',
  fotao: 'fotão',
  foton: 'fóton',
  fouca: 'fouça',
  fouco: 'fouço',
  fovea: 'fóvea',
  frape: 'frapê',
  freon: 'fréon',
  fruia: 'fruía',
  fucai: 'fuçai',
  fucam: 'fuçam',
  fucar: 'fuçar',
  fucas: 'fuças',
  fucea: 'fúcea',
  fucou: 'fuçou',
  fufia: 'fúfia',
  fufio: 'fúfio',
  fujao: 'fujão',
  fulao: 'fulão',
  fumao: 'fumão',
  fumeo: 'fúmeo',
  funeu: 'funéu',
  furao: 'furão',
  furia: 'fúria',
  fusao: 'fusão',
  fusel: 'fúsel',
  fusil: 'fúsil',
  futil: 'fútil',
  fuzue: 'fuzuê',
  gabao: 'gabão',
  gabeu: 'gabéu',
  gabia: 'gábia',
  gabio: 'gábio',
  gadao: 'gadão',
  gafem: 'gafém',
  gafio: 'gáfio',
  gagao: 'gagão',
  gajao: 'gajão',
  galao: 'galão',
  galax: 'gálax',
  galea: 'gálea',
  galem: 'galém',
  galia: 'gália',
  galio: 'gálio',
  gamao: 'gamão',
  gamba: 'gambá',
  gamia: 'gâmia',
  ganca: 'gança',
  ganco: 'ganço',
  ganes: 'ganês',
  ganze: 'ganzé',
  garao: 'garão',
  garca: 'garça',
  garco: 'garço',
  gatao: 'gatão',
  gavea: 'gávea',
  gazao: 'gazão',
  gazeo: 'gázeo',
  gazio: 'gázio',
  gemea: 'gêmea',
  gemeo: 'gêmeo',
  genio: 'gênio',
  gibao: 'gibão',
  gicao: 'gicão',
  gicle: 'giclê',
  gigia: 'gígia',
  gilia: 'gília',
  girao: 'girão',
  giria: 'gíria',
  girio: 'gírio',
  glace: 'glacê',
  gluao: 'gluão',
  gluon: 'glúon',
  gobio: 'góbio',
  godao: 'godão',
  godia: 'gódia',
  goias: 'goiás',
  gonga: 'gongá',
  gonio: 'gônio',
  gonis: 'gônis',
  gozao: 'gozão',
  graca: 'graça',
  graos: 'grãos',
  grejo: 'grejó',
  grena: 'grená',
  grijo: 'grijó',
  grolo: 'groló',
  gruia: 'gruía',
  guaca: 'guacá',
  guacu: 'guaçu',
  guaiu: 'guaiú',
  guaja: 'guajá',
  guana: 'guaná',
  guape: 'guapé',
  guara: 'guará',
  guare: 'guaré',
  guato: 'guató',
  guede: 'guedé',
  guiao: 'guião',
  guiba: 'guibá',
  guigo: 'guigó',
  guine: 'guiné',
  guipa: 'guipá',
  habes: 'habés',
  habil: 'hábil',
  haden: 'háden',
  halux: 'hálux',
  hapax: 'hápax',
  harem: 'harém',
  hauca: 'haúça',
  heber: 'héber',
  helas: 'hélas',
  helia: 'hélia',
  helio: 'hélio',
  helix: 'hélix',
  hepar: 'hépar',
  hepia: 'hépia',
  hereu: 'heréu',
  heroi: 'herói',
  heroo: 'herôo',
  hevea: 'hévea',
  hiala: 'híala',
  hifen: 'hífen',
  himen: 'hímen',
  holao: 'holão',
  homao: 'homão',
  hovea: 'hóvea',
  humil: 'húmil',
  humus: 'húmus',
  iagua: 'iaguá',
  iamos: 'íamos',
  iansa: 'iansã',
  iatai: 'iataí',
  ibama: 'ibama',
  ibaro: 'ibaró',
  ibere: 'iberê',
  icacu: 'icaçu',
  icado: 'içado',
  icais: 'içais',
  icara: 'içara',
  icaro: 'ícaro',
  icava: 'içava',
  ichao: 'ichão',
  icipo: 'icipó',
  icone: 'ícone',
  icore: 'ícore',
  ictis: 'íctis',
  idola: 'ídola',
  idolo: 'ídolo',
  igapo: 'igapó',
  ignea: 'ígnea',
  igneo: 'ígneo',
  igupa: 'igupá',
  iiaba: 'iiabá',
  ijexa: 'ijexá',
  ilaro: 'ílaro',
  ileon: 'íleon',
  ilheu: 'ilhéu',
  ilhos: 'ilhós',
  ilica: 'iliça',
  ilico: 'iliço',
  ilion: 'ílion',
  impar: 'ímpar',
  impia: 'ímpia',
  impio: 'ímpio',
  impoe: 'impõe',
  impos: 'impôs',
  inaco: 'ínaco',
  inaia: 'inaiá',
  inaja: 'inajá',
  incai: 'inçai',
  incam: 'inçam',
  incar: 'inçar',
  incoe: 'incõe',
  incou: 'inçou',
  index: 'índex',
  india: 'índia',
  indio: 'índio',
  indri: 'índri',
  indua: 'índua',
  ingai: 'ingaí',
  ingua: 'íngua',
  inion: 'ínion',
  insua: 'ínsua',
  intui: 'intuí',
  inula: 'ínula',
  inves: 'invés',
  invio: 'ínvio',
  ioios: 'ioiôs',
  ionio: 'iônio',
  iotio: 'iótio',
  ipete: 'ipetê',
  iracu: 'iraçu',
  irama: 'iramá',
  irere: 'irerê',
  irira: 'irirá',
  irmao: 'irmão',
  irmas: 'irmãs',
  irucu: 'iruçu',
  isate: 'ísate',
  islao: 'islão',
  italo: 'ítalo',
  itaua: 'itauá',
  itria: 'ítria',
  itrio: 'ítrio',
  jabao: 'jabão',
  jacas: 'jacás',
  jacea: 'jácea',
  jacui: 'jacuí',
  jaico: 'jaicó',
  jaime: 'jaime',
  jalao: 'jalão',
  jambe: 'jambé',
  janau: 'janaú',
  japao: 'japão',
  japix: 'jápix',
  japue: 'japué',
  japui: 'japuí',
  jaque: 'jaqué',
  javae: 'javaé',
  jeico: 'jeicó',
  jembe: 'jembé',
  jemia: 'jemiá',
  jeova: 'jeová',
  jepia: 'jepiá',
  jepio: 'jepió',
  jesus: 'jesus',
  jetai: 'jetaí',
  jicao: 'jicão',
  jicui: 'jiçuí',
  jipao: 'jipão',
  jiroe: 'jiroé',
  jocal: 'joçal',
  jogao: 'jogão',
  joias: 'jóias',
  joiba: 'joíba',
  joica: 'joiça',
  jonia: 'jônia',
  jonio: 'jônio',
  jorao: 'jorão',
  jouca: 'jouça',
  jubai: 'jubaí',
  jubao: 'jubão',
  juiza: 'juíza',
  juizo: 'juízo',
  julia: 'júlia',
  julio: 'júlio',
  junca: 'junça',
  jupao: 'jupão',
  jupia: 'jupiá',
  jupua: 'jupuá',
  jurao: 'jurão',
  jusao: 'jusão',
  jutai: 'jutaí',
  juvia: 'júvia',
  labeu: 'labéu',
  labia: 'lábia',
  labil: 'lábil',
  labio: 'lábio',
  lacai: 'laçai',
  lacam: 'laçam',
  lacao: 'lação',
  lacar: 'laçar',
  lacas: 'laças',
  lacio: 'lácio',
  lacon: 'lácon',
  lacos: 'laços',
  lacou: 'laçou',
  ladao: 'ládão',
  lagao: 'lagão',
  lajao: 'lajão',
  lamia: 'lâmia',
  lamio: 'lâmio',
  lanca: 'lança',
  lanco: 'lanço',
  lando: 'landô',
  laneo: 'lâneo',
  lanio: 'lânio',
  lapao: 'lapão',
  lapia: 'lapiá',
  lapis: 'lápis',
  lareu: 'laréu',
  larix: 'lárix',
  lasia: 'lásia',
  latao: 'latão',
  latea: 'látea',
  lateo: 'láteo',
  latex: 'látex',
  laude: 'laúde',
  laule: 'laulé',
  lauza: 'laúza',
  lazao: 'lazão',
  legao: 'legão',
  legua: 'légua',
  lelia: 'lélia',
  lemur: 'lêmur',
  lenao: 'lenão',
  lenco: 'lenço',
  leneo: 'lêneo',
  leoes: 'leões',
  lepis: 'lépis',
  lerao: 'lerão',
  leria: 'léria',
  lesao: 'lesão',
  letao: 'letão',
  lexis: 'léxis',
  liaca: 'liaça',
  liber: 'líber',
  libio: 'líbio',
  licao: 'lição',
  licia: 'lícia',
  licio: 'lício',
  licos: 'liços',
  lider: 'líder',
  lidio: 'lídio',
  ligeo: 'lígeo',
  ligio: 'lígio',
  lilas: 'lilás',
  lilio: 'lílio',
  limao: 'limão',
  linea: 'línea',
  lineo: 'líneo',
  lirao: 'lirão',
  liria: 'líria',
  lirio: 'lírio',
  lisio: 'lísio',
  litao: 'litão',
  litia: 'lítia',
  litio: 'lítio',
  lituo: 'lítuo',
  livia: 'lívia',
  lixao: 'lixão',
  lobao: 'lobão',
  locao: 'loção',
  lodao: 'lódão',
  lofio: 'lófio',
  logea: 'lógea',
  loica: 'loiça',
  lolio: 'lólio',
  loris: 'lóris',
  lotus: 'lótus',
  louca: 'louça',
  loxia: 'lóxia',
  lucao: 'lucão',
  lucio: 'lúcio',
  ludio: 'lúdio',
  luina: 'luína',
  lulao: 'lulão',
  lumen: 'lúmen',
  lupia: 'lúpia',
  lupus: 'lúpus',
  luria: 'lúria',
  luteo: 'lúteo',
  luzie: 'luziê',
  luzio: 'lúzio',
  mabiu: 'mabiú',
  macaa: 'macaá',
  macae: 'macaé',
  macai: 'maçai',
  macal: 'maçal',
  macam: 'maçam',
  macao: 'mação',
  macas: 'maçãs',
  macea: 'mácea',
  macom: 'maçom',
  macos: 'maços',
  macou: 'maçou',
  madia: 'mádia',
  mafau: 'mafaú',
  mafia: 'máfia',
  mafua: 'mafuá',
  magne: 'magné',
  magoa: 'mágoa',
  maiao: 'maião',
  maica: 'maíça',
  maina: 'mainá',
  maira: 'maíra',
  maita: 'maitá',
  malsa: 'malsã',
  mamae: 'mamãe',
  mamao: 'mamão',
  manes: 'manês',
  manha: 'manhã',
  mante: 'mantê',
  manue: 'manuê',
  mapao: 'mapão',
  mapua: 'mapuá',
  marao: 'marão',
  mario: 'mário',
  maroo: 'mároo',
  marte: 'marte',
  marua: 'maruá',
  marui: 'maruí',
  matao: 'matão',
  mateu: 'matéu',
  matia: 'mátia',
  matri: 'mátri',
  matue: 'matué',
  mauba: 'maúba',
  maues: 'maués',
  mauis: 'mauís',
  maujo: 'maújo',
  maura: 'maurá',
  mavia: 'mávia',
  mecam: 'meçam',
  mecas: 'meças',
  mecia: 'mécia',
  medao: 'medão',
  media: 'média',
  medio: 'médio',
  meiao: 'meião',
  melao: 'melão',
  meleo: 'méleo',
  melia: 'mélia',
  meloe: 'méloe',
  membe: 'membé',
  menha: 'menhã',
  merce: 'mercê',
  merio: 'merió',
  merui: 'meruí',
  mesao: 'mesão',
  mesio: 'mésio',
  meson: 'méson',
  mesua: 'mésua',
  metie: 'metiê',
  meule: 'meúle',
  mexao: 'mexão',
  miche: 'michê',
  micio: 'mício',
  midia: 'mídia',
  mijao: 'mijão',
  mijui: 'mijuí',
  milao: 'milão',
  mileo: 'míleo',
  minio: 'mínio',
  minis: 'mínis',
  miope: 'míope',
  mirao: 'mirão',
  miris: 'míris',
  mirza: 'mirzá',
  misso: 'missô',
  miuca: 'miúça',
  miuda: 'miúda',
  miude: 'miúde',
  miudo: 'miúdo',
  miufa: 'miúfa',
  miulo: 'miúlo',
  miura: 'miúra',
  miuro: 'miúro',
  miuva: 'miúva',
  mixna: 'mixná',
  moadi: 'moádi',
  mobil: 'móbil',
  mocao: 'moção',
  mocos: 'moços',
  mocui: 'mocuí',
  modio: 'módio',
  mogao: 'mogão',
  moiam: 'moíam',
  moiao: 'moião',
  moias: 'moías',
  moida: 'moída',
  moido: 'moído',
  moina: 'móina',
  molio: 'mólio',
  monde: 'mondé',
  monhe: 'monhé',
  moqua: 'móqua',
  morao: 'morão',
  mosba: 'mosbá',
  movel: 'móvel',
  mozes: 'mozés',
  muari: 'muári',
  mucia: 'muçia',
  mucua: 'muçuã',
  mucui: 'mucuí',
  mucum: 'muçum',
  mufui: 'mufuí',
  mugil: 'múgil',
  muilo: 'muílo',
  muleo: 'múleo',
  mumbe: 'mumbé',
  mumia: 'múmia',
  munde: 'mundé',
  mundi: 'múndi',
  munus: 'múnus',
  murca: 'murça',
  murex: 'múrex',
  muria: 'múria',
  murui: 'muruí',
  murza: 'murzá',
  musme: 'musmé',
  musso: 'mussó',
  mutua: 'mútua',
  mutuo: 'mútuo',
  muviu: 'muviú',
  muzua: 'múzua',
  nabao: 'nábão',
  nacao: 'nação',
  nacar: 'nácar',
  nagao: 'nagão',
  nagua: 'nágua',
  nanas: 'nanás',
  nasca: 'nasça',
  nasco: 'nasço',
  nasia: 'násia',
  nasio: 'násio',
  nassi: 'nássi',
  nasua: 'násua',
  navao: 'návão',
  navia: 'návia',
  naxia: 'náxia',
  naxio: 'náxio',
  nazir: 'názir',
  nedio: 'nédio',
  negao: 'negão',
  nelia: 'nélia',
  nenem: 'neném',
  nenes: 'nenês',
  nenia: 'nênia',
  nenio: 'nênio',
  neons: 'néons',
  neper: 'néper',
  nepia: 'népia',
  neria: 'néria',
  nerio: 'nério',
  neris: 'néris',
  neusa: 'neusa',
  nevao: 'nevão',
  nevoa: 'névoa',
  niboe: 'niboé',
  nifao: 'nifão',
  nigua: 'nígua',
  nilgo: 'nilgó',
  nilio: 'nílio',
  nimia: 'nímia',
  nimio: 'nímio',
  niopo: 'niopó',
  nipao: 'nipão',
  niton: 'níton',
  nivea: 'nívea',
  nivel: 'nível',
  niveo: 'níveo',
  nobel: 'nobel',
  nobio: 'nóbio',
  nocao: 'noção',
  nodio: 'nódio',
  nodoa: 'nódoa',
  nogao: 'nogão',
  nomea: 'nomeá',
  nonio: 'nônio',
  norca: 'norça',
  noria: 'nória',
  norio: 'nório',
  novea: 'nóvea',
  noxia: 'nóxia',
  noxio: 'nóxio',
  nubia: 'núbia',
  nubil: 'núbil',
  nubio: 'núbio',
  nucao: 'nução',
  nucio: 'núcio',
  nufar: 'núfar',
  numen: 'númen',
  nuveo: 'núveo',
  nuxia: 'núxia',
  oasis: 'oásis',
  obelo: 'óbelo',
  obice: 'óbice',
  obito: 'óbito',
  obolo: 'óbolo',
  obtem: 'obtém',
  obvem: 'obvêm',
  obvia: 'óbvia',
  obvio: 'óbvio',
  ocide: 'ócide',
  ocimo: 'ócimo',
  ocios: 'ócios',
  ocrea: 'ócrea',
  oculo: 'óculo',
  odeao: 'odeão',
  odeon: 'odéon',
  odios: 'ódios',
  ofaie: 'ofaié',
  ofico: 'ófico',
  ofrio: 'ófrio',
  ofris: 'ófris',
  ofuro: 'ofurô',
  oicam: 'oiçam',
  oidio: 'oídio',
  oitao: 'oitão',
  olare: 'olaré',
  oleos: 'óleos',
  olhao: 'olhão',
  ombra: 'ombrã',
  omega: 'ômega',
  omele: 'omelê',
  oncao: 'onção',
  oncas: 'onças',
  onfua: 'onfuá',
  opalo: 'ópalo',
  opcao: 'opção',
  opera: 'ópera',
  opido: 'ópido',
  opilo: 'ópilo',
  opoem: 'opõem',
  opoes: 'opões',
  opora: 'oporá',
  oquea: 'oqueá',
  orcai: 'orçai',
  orcam: 'orçam',
  orcar: 'orçar',
  orcaz: 'orçaz',
  orcou: 'orçou',
  orfao: 'órfão',
  orfas: 'órfãs',
  orfia: 'órfia',
  orfio: 'órfio',
  orgao: 'órgão',
  orgio: 'órgio',
  orion: 'órion',
  orixa: 'orixá',
  orlea: 'orleã',
  orobo: 'órobo',
  oroca: 'oroça',
  oruco: 'orucó',
  oscar: 'óscar',
  osido: 'ósido',
  osmia: 'ósmia',
  osmio: 'ósmio',
  ossea: 'óssea',
  osseo: 'ósseo',
  ostio: 'óstio',
  otica: 'ótica',
  otico: 'ótico',
  otima: 'ótima',
  otimo: 'ótimo',
  ototo: 'ototó',
  oucam: 'ouçam',
  oucao: 'oução',
  oucas: 'ouças',
  ourem: 'ourém',
  outao: 'outão',
  ovalo: 'óvalo',
  ovano: 'óvano',
  ovnis: 'óvnis',
  ovulo: 'óvulo',
  oxala: 'oxalá',
  oxido: 'óxido',
  pacai: 'pacaí',
  pacao: 'pacão',
  pacha: 'pachã',
  pacos: 'paços',
  pades: 'padês',
  padoa: 'pádoa',
  padua: 'pádua',
  paete: 'paetê',
  pafia: 'páfia',
  pafio: 'páfio',
  pagao: 'pagão',
  paiao: 'paião',
  paiba: 'paíba',
  pajao: 'pajão',
  pajes: 'pajés',
  pajeu: 'pajeú',
  palao: 'palão',
  palea: 'pálea',
  paleo: 'páleo',
  palio: 'pálio',
  pamoa: 'pamoá',
  panao: 'panão',
  panax: 'pânax',
  panca: 'pança',
  panro: 'panró',
  papao: 'papão',
  papas: 'papás',
  paqua: 'paquã',
  paque: 'paquê',
  parao: 'parão',
  parau: 'paraú',
  parea: 'párea',
  pareo: 'pareô',
  paria: 'pária',
  pario: 'pário',
  parne: 'parné',
  parsi: 'pársi',
  parui: 'paruí',
  pasca: 'pasça',
  pasco: 'pasço',
  patai: 'pataí',
  patao: 'patão',
  patem: 'patém',
  pates: 'patês',
  patio: 'pátio',
  patoa: 'patoá',
  patri: 'patri',
  patua: 'patuá',
  pauna: 'paúna',
  paura: 'paúra',
  pavao: 'pavão',
  paves: 'pavês',
  paxau: 'paxaú',
  pazao: 'pazão',
  pcdob: 'pcdob',
  peaca: 'peaça',
  pecam: 'peçam',
  pecem: 'pecém',
  pecos: 'peçós',
  pedro: 'pedro',
  pegao: 'pegão',
  pelao: 'pelão',
  pelem: 'pelém',
  pelio: 'pélio',
  penao: 'penão',
  pengo: 'pengó',
  penia: 'pênia',
  penis: 'pênis',
  peoes: 'peões',
  peone: 'péone',
  pepia: 'pépia',
  perea: 'pereá',
  perem: 'perém',
  peroa: 'peroá',
  petao: 'petão',
  petem: 'petém',
  petia: 'petiá',
  petiu: 'petiú',
  peuco: 'peúco',
  peuga: 'peúga',
  peule: 'peúle',
  peuva: 'peúva',
  pexao: 'pexão',
  pezao: 'pezão',
  piaco: 'piaçó',
  piafe: 'piafé',
  piape: 'piapé',
  piaui: 'piauí',
  picao: 'picão',
  picau: 'picaú',
  picea: 'pícea',
  piceo: 'píceo',
  picua: 'picuá',
  picui: 'picuí',
  pidao: 'pidão',
  piero: 'píero',
  pifao: 'pifão',
  pifia: 'pífia',
  pifio: 'pífio',
  piite: 'piíte',
  pijin: 'píjin',
  pilao: 'pilão',
  pileo: 'píleo',
  pileu: 'piléu',
  pinca: 'pinça',
  pinco: 'pinço',
  pineo: 'píneo',
  pineu: 'pinéu',
  pinhe: 'pinhé',
  pioes: 'piões',
  pioie: 'pioié',
  piper: 'píper',
  piqua: 'píqua',
  pirai: 'piraí',
  pirao: 'pirão',
  pirau: 'piraú',
  piroa: 'piroá',
  pirre: 'pirré',
  pirua: 'piruá',
  pisao: 'pisão',
  piseo: 'píseo',
  pitao: 'pitão',
  pitem: 'pitém',
  piteu: 'pitéu',
  pitia: 'pítia',
  pitio: 'pítio',
  pitiu: 'pitiú',
  piton: 'píton',
  pitua: 'pituá',
  pitui: 'pituí',
  piuba: 'piúba',
  piuca: 'piúca',
  piugo: 'piúgo',
  piuna: 'piúna',
  piuva: 'piúva',
  pivos: 'pivôs',
  pixeu: 'pixéu',
  pixua: 'pixuá',
  place: 'placê',
  plato: 'platô',
  poacu: 'poaçu',
  pocal: 'poçal',
  pocao: 'poção',
  pocas: 'poças',
  pocos: 'poços',
  podao: 'podão',
  podex: 'pódex',
  podio: 'pódio',
  podoi: 'podói',
  polen: 'pólen',
  poles: 'polés',
  polex: 'pólex',
  polio: 'pólio',
  polis: 'pólis',
  polos: 'pólos',
  polui: 'poluí',
  polux: 'pólux',
  ponca: 'poncã',
  ponco: 'ponço',
  ponei: 'pônei',
  ponje: 'ponjê',
  popao: 'popão',
  popia: 'popiá',
  porao: 'porão',
  poras: 'porás',
  porem: 'porém',
  porio: 'pório',
  potea: 'pótea',
  povao: 'povão',
  povoa: 'póvoa',
  praca: 'praça',
  praja: 'prajá',
  preas: 'preás',
  preca: 'preça',
  preco: 'preço',
  preon: 'préon',
  preve: 'prevê',
  priao: 'prião',
  prion: 'príon',
  prive: 'privê',
  proca: 'procá',
  prove: 'provê',
  pruia: 'pruía',
  puaco: 'puaço',
  puacu: 'puaçu',
  pubis: 'púbis',
  pucto: 'puctó',
  pugil: 'púgil',
  puiam: 'puíam',
  puias: 'puías',
  puida: 'puída',
  puido: 'puído',
  puira: 'puíra',
  puita: 'puíta',
  pulao: 'pulão',
  pulex: 'púlex',
  punca: 'punça',
  punco: 'punço',
  punde: 'pundé',
  purui: 'puruí',
  puvia: 'puviá',
  puxao: 'puxão',
  quale: 'qualé',
  quaro: 'quaró',
  quata: 'quatá',
  quece: 'quecé',
  quede: 'quedê',
  quepi: 'quépi',
  quere: 'querê',
  quica: 'quiçá',
  quice: 'quicê',
  quipa: 'quipá',
  quipe: 'quipé',
  quito: 'quitó',
  quiui: 'quiuí',
  quixo: 'quixó',
  rabao: 'rabão',
  rabia: 'rábia',
  racao: 'ração',
  racas: 'raças',
  racio: 'rácio',
  racoa: 'raçoa',
  racoe: 'raçoe',
  racoo: 'raçoo',
  radao: 'radão',
  radia: 'rádia',
  radio: 'rádio',
  radon: 'rádon',
  rafia: 'ráfia',
  ragio: 'rágio',
  ragla: 'raglã',
  raiao: 'raião',
  raita: 'raíta',
  rajao: 'rajão',
  ralao: 'ralão',
  rales: 'ralés',
  rameo: 'râmeo',
  ranco: 'ranço',
  rapao: 'rapão',
  raqui: 'ráqui',
  rasao: 'rasão',
  ratao: 'ratão',
  razao: 'razão',
  reaca: 'reaça',
  rebem: 'rebém',
  rebus: 'rébus',
  recao: 'recão',
  recem: 'recém',
  recha: 'rechã',
  recho: 'rechô',
  recio: 'récio',
  redea: 'rédea',
  redem: 'redém',
  redia: 'rédia',
  refem: 'refém',
  regia: 'régia',
  regie: 'régie',
  regio: 'régio',
  regua: 'régua',
  reivo: 'reivó',
  rejao: 'rejão',
  remoe: 'remoê',
  remoi: 'remói',
  renao: 'renão',
  renio: 'rênio',
  repoe: 'repõe',
  repos: 'repôs',
  rerao: 'rerão',
  retem: 'retém',
  reuna: 'reúna',
  reune: 'reúne',
  reuno: 'reúno',
  reuso: 'reúso',
  revem: 'revêm',
  reves: 'revés',
  revoa: 'révoa',
  rexia: 'réxia',
  rezao: 'rezão',
  ricai: 'riçai',
  ricam: 'riçam',
  ricar: 'riçar',
  ricas: 'riças',
  ricio: 'rício',
  ricol: 'riçol',
  ricou: 'riçou',
  rieis: 'ríeis',
  rieti: 'riéti',
  rifao: 'rifão',
  rigel: 'rígel',
  rijao: 'rijão',
  rimel: 'rímel',
  rinca: 'rinça',
  rinco: 'rinço',
  ripio: 'rípio',
  rirao: 'rirão',
  risao: 'risão',
  ritao: 'ritão',
  ritio: 'rítio',
  riton: 'ríton',
  riuta: 'riúta',
  rober: 'róber',
  robos: 'robôs',
  robur: 'róbur',
  rocai: 'roçai',
  rocam: 'roçam',
  rocao: 'rocão',
  rocar: 'roçar',
  rocas: 'roças',
  roclo: 'rocló',
  rocou: 'roçou',
  rodao: 'rodão',
  rodio: 'ródio',
  roiam: 'roíam',
  roias: 'roías',
  roido: 'roído',
  rojao: 'rojão',
  rolao: 'rolão',
  romao: 'romão',
  romas: 'romãs',
  rondo: 'rondó',
  rongo: 'rongó',
  ronto: 'rontó',
  ropia: 'rópia',
  rosao: 'rosão',
  rosea: 'rósea',
  roseo: 'róseo',
  rotia: 'rótia',
  ruaca: 'ruaça',
  rubeo: 'rúbeo',
  rubia: 'rúbia',
  rucai: 'ruçai',
  rucam: 'ruçam',
  rucar: 'ruçar',
  rucas: 'ruças',
  rucos: 'ruços',
  rucou: 'ruçou',
  rufio: 'rúfio',
  rugbi: 'rúgbi',
  rugio: 'rúgio',
  ruiam: 'ruíam',
  ruias: 'ruías',
  ruido: 'ruído',
  ruina: 'ruína',
  ruira: 'ruirá',
  rumen: 'rúmen',
  runco: 'runcó',
  saara: 'saara',
  sabao: 'sabão',
  sabas: 'sabás',
  sabia: 'sábia',
  sabio: 'sábio',
  sabiu: 'sabiú',
  sacai: 'sacaí',
  sacao: 'sacão',
  sache: 'sachê',
  sacri: 'sácri',
  sacue: 'sacuê',
  sadao: 'sadão',
  sadra: 'sadrá',
  safao: 'safão',
  safeo: 'sáfeo',
  sagao: 'sagão',
  sagio: 'ságio',
  sagua: 'saguá',
  saiao: 'saião',
  saico: 'saíco',
  saida: 'saída',
  saido: 'saído',
  saije: 'saijé',
  saine: 'sainé',
  saipe: 'saipé',
  saira: 'sairá',
  saire: 'sairé',
  saita: 'saíta',
  saiva: 'saivá',
  saixe: 'saixê',
  salao: 'salão',
  salem: 'salém',
  salio: 'sálio',
  salix: 'sálix',
  samao: 'samão',
  samio: 'sâmio',
  sandi: 'sândi',
  sanie: 'sânie',
  sanvo: 'sanvó',
  sapao: 'sapão',
  sapia: 'sápia',
  sapua: 'sapuá',
  sarao: 'sarão',
  saras: 'sarás',
  sarca: 'sarça',
  sarne: 'sarné',
  saroe: 'saroé',
  sarta: 'sartã',
  sarua: 'saruá',
  sarue: 'saruê',
  satao: 'satão',
  sauba: 'saúba',
  sauco: 'saúco',
  sauda: 'saúda',
  saude: 'saúde',
  saudo: 'saúdo',
  sauga: 'saúga',
  sauia: 'sauiá',
  saupe: 'saupé',
  saura: 'saurá',
  saute: 'sauté',
  sauva: 'saúva',
  savel: 'sável',
  savia: 'saviá',
  saxao: 'saxão',
  saxeo: 'sáxeo',
  sazao: 'sazão',
  secao: 'seção',
  secia: 'sécia',
  secio: 'sécio',
  sedao: 'sedão',
  sedem: 'sedém',
  segao: 'segão',
  seica: 'seiça',
  selao: 'selão',
  selio: 'sélio',
  semea: 'sêmea',
  semel: 'sêmel',
  semen: 'sêmen',
  semis: 'sêmis',
  senao: 'senão',
  senio: 'sênio',
  sepia: 'sépia',
  sepio: 'sépio',
  sequi: 'séqui',
  serao: 'serão',
  seras: 'serás',
  seria: 'séria',
  serie: 'série',
  serio: 'sério',
  seriu: 'seriú',
  serta: 'sertã',
  serum: 'sérum',
  sesea: 'sésea',
  sesia: 'sésia',
  seter: 'séter',
  sezao: 'sezão',
  sicon: 'sícon',
  sifao: 'sifão',
  sigmo: 'sigmó',
  siler: 'síler',
  silex: 'sílex',
  simao: 'simão',
  simel: 'símel',
  simia: 'símia',
  simil: 'símil',
  simio: 'símio',
  sinao: 'sinão',
  sinha: 'sinhá',
  sinho: 'sinhô',
  sinxo: 'sinxó',
  siria: 'síria',
  sirio: 'sírio',
  siriu: 'siriú',
  sisao: 'sisão',
  sisso: 'sissó',
  sitio: 'sítio',
  siuba: 'siúba',
  sobpe: 'sobpé',
  socao: 'socão',
  socia: 'sócia',
  socio: 'sócio',
  socoi: 'socoí',
  sodio: 'sódio',
  sofas: 'sofás',
  sogua: 'soguá',
  soido: 'soído',
  solao: 'solão',
  solea: 'sólea',
  soleo: 'sóleo',
  solio: 'sólio',
  somie: 'somiê',
  sonia: 'sônia',
  sopao: 'sopão',
  sopes: 'sopés',
  sorca: 'sorça',
  sorex: 'sórex',
  soria: 'sória',
  sosia: 'sósia',
  sotaa: 'sotaã',
  sotao: 'sótão',
  soveu: 'sovéu',
  suacu: 'suaçu',
  suari: 'suári',
  suber: 'súber',
  sucao: 'sução',
  sucia: 'súcia',
  sucio: 'súcio',
  sudao: 'sudão',
  sufle: 'suflê',
  suica: 'suíça',
  suico: 'suíço',
  suina: 'suína',
  suino: 'suíno',
  suite: 'suíte',
  sulao: 'sulão',
  suomi: 'suômi',
  supoe: 'supõe',
  supos: 'supôs',
  surca: 'surça',
  surio: 'súrio',
  susao: 'susão',
  sutia: 'sutiã',
  tabao: 'tabão',
  tabua: 'tábua',
  tacao: 'tacão',
  tacas: 'taças',
  tacia: 'tácia',
  tacua: 'tacuá',
  tafia: 'tafiá',
  tafio: 'táfio',
  tagua: 'taguá',
  taifo: 'taifó',
  tajas: 'tajás',
  talao: 'talão',
  taler: 'táler',
  talia: 'tália',
  talio: 'tálio',
  talus: 'tálus',
  tamao: 'tamão',
  tambi: 'tâmbi',
  tamem: 'tamém',
  tamia: 'tâmia',
  tamil: 'tâmil',
  tamul: 'tâmul',
  tapao: 'tapão',
  tapia: 'tapiá',
  tapii: 'tapií',
  tapiu: 'tapiú',
  tarba: 'tarbá',
  taros: 'tarós',
  tarta: 'tartã',
  tasio: 'tásio',
  tatil: 'tátil',
  tatui: 'tatuí',
  tatze: 'tatzé',
  tauba: 'taúba',
  tavao: 'tavão',
  taxis: 'táxis',
  tecam: 'teçam',
  tecas: 'teças',
  tecoa: 'tecóa',
  tedeu: 'tedéu',
  tedio: 'tédio',
  tegao: 'tegão',
  teina: 'teína',
  teiro: 'teiró',
  teite: 'teité',
  telao: 'telão',
  telio: 'télio',
  temao: 'temão',
  tembe: 'tembé',
  temio: 'têmio',
  temne: 'temné',
  tenar: 'tênar',
  tenca: 'tença',
  tenia: 'tênia',
  tenis: 'tênis',
  tenue: 'tênue',
  terao: 'terão',
  teras: 'terás',
  terca: 'terça',
  terco: 'terço',
  terio: 'tério',
  tesao: 'tesão',
  tesio: 'tésio',
  tesis: 'tésis',
  teteu: 'tetéu',
  tetio: 'tétio',
  tetis: 'tétis',
  tetum: 'tétum',
  teuba: 'teúba',
  teuda: 'teúda',
  teudo: 'teúdo',
  teves: 'tevês',
  tiade: 'tíade',
  tiata: 'tiatã',
  tibia: 'tíbia',
  tibio: 'tíbio',
  ticao: 'tição',
  ticio: 'tício',
  tiete: 'tietê',
  tifao: 'tifão',
  tifia: 'tífia',
  tilea: 'tílea',
  tilia: 'tília',
  timao: 'timão',
  timbe: 'timbé',
  timbo: 'timbó',
  timio: 'tímio',
  tinea: 'tínea',
  tiner: 'tíner',
  tinho: 'tinhó',
  tiote: 'tiotê',
  tipao: 'tipão',
  tipio: 'tipió',
  tipoi: 'tipói',
  tirao: 'tirão',
  tirio: 'tírio',
  tiris: 'tíris',
  tisio: 'tísio',
  titao: 'titão',
  titas: 'titãs',
  titue: 'titué',
  tiuba: 'tiúba',
  tiupa: 'tiupá',
  tiuva: 'tiúva',
  tocai: 'tócai',
  toica: 'toiça',
  toico: 'toiço',
  tolao: 'tolão',
  tolia: 'tólia',
  tomao: 'tomão',
  tomas: 'tomás',
  tomio: 'tômio',
  tonus: 'tônus',
  topos: 'tópos',
  torai: 'toraí',
  torao: 'torão',
  toras: 'torás',
  torax: 'tórax',
  torca: 'torça',
  torco: 'torço',
  torem: 'torém',
  toria: 'tória',
  torio: 'tório',
  tosao: 'tosão',
  touco: 'touço',
  traca: 'traça',
  traco: 'traço',
  traia: 'traía',
  trara: 'trará',
  trico: 'tricô',
  tripe: 'tripé',
  troco: 'troço',
  trois: 'tróis',
  truao: 'truão',
  tuaia: 'tuaiá',
  tuber: 'túber',
  tucao: 'tucão',
  tufao: 'tufão',
  tuira: 'tuíra',
  tuita: 'tuíta',
  tuite: 'tuíte',
  tulia: 'túlia',
  tulio: 'túlio',
  tunel: 'túnel',
  turne: 'turnê',
  tutao: 'tutão',
  tutsi: 'tútsi',
  uabui: 'uabuí',
  uacai: 'uaçaí',
  uaiba: 'uaíba',
  uaica: 'uaicá',
  uaita: 'uaitá',
  uambe: 'uambé',
  uamoi: 'uamói',
  uania: 'uaniá',
  uapes: 'uapés',
  uaria: 'uariá',
  uaucu: 'uauçu',
  uaupe: 'uaupé',
  uaura: 'uaurá',
  uaxua: 'uaxuá',
  ubata: 'ubatã',
  ubere: 'úbere',
  ubero: 'úbero',
  ubucu: 'ubuçu',
  uchao: 'uchão',
  ucima: 'ucimá',
  uiape: 'uiapé',
  uique: 'uiqué',
  uiste: 'uíste',
  ujara: 'ujará',
  ulema: 'ulemá',
  umaua: 'umauá',
  umero: 'úmero',
  umida: 'úmida',
  umido: 'úmido',
  uncao: 'unção',
  uncia: 'úncia',
  ungue: 'úngue',
  unhao: 'unhão',
  uniao: 'união',
  unica: 'única',
  unico: 'único',
  unsia: 'únsia',
  untue: 'untué',
  uraco: 'úraco',
  uracu: 'uraçu',
  urano: 'úrano',
  urceo: 'úrceo',
  urico: 'úrico',
  uruba: 'urubá',
  urupa: 'urupá',
  urupe: 'urupê',
  usara: 'usará',
  usnea: 'úsnea',
  ustao: 'ustão',
  uteis: 'úteis',
  utero: 'útero',
  uvaca: 'uvaça',
  uvacu: 'uvaçu',
  uvico: 'úvico',
  uvido: 'úvido',
  uvula: 'úvula',
  vacao: 'vacão',
  vacua: 'vacuá',
  vacuo: 'vácuo',
  vagao: 'vagão',
  vaixa: 'vaixá',
  valao: 'valão',
  vance: 'vancê',
  varao: 'varão',
  vario: 'vário',
  vassa: 'vassá',
  vatio: 'vátio',
  vaulo: 'vauló',
  vaura: 'vaurá',
  vazao: 'vazão',
  velea: 'vélea',
  velia: 'vélia',
  velum: 'vélum',
  venca: 'vença',
  venco: 'venço',
  venia: 'vênia',
  venus: 'vênus',
  verao: 'verão',
  veras: 'verás',
  verca: 'verça',
  verge: 'vergê',
  verio: 'vério',
  vetao: 'vetão',
  vicai: 'viçai',
  vicam: 'viçam',
  vicar: 'viçar',
  vicas: 'viças',
  vicio: 'vício',
  vicoa: 'vícoa',
  vicor: 'viçor',
  vicou: 'viçou',
  vidao: 'vidão',
  video: 'vídeo',
  vidia: 'vídia',
  vieis: 'víeis',
  vigil: 'vígil',
  vilao: 'vilão',
  vimea: 'vímea',
  vinea: 'vínea',
  vineo: 'víneo',
  virao: 'virão',
  virus: 'vírus',
  visao: 'visão',
  vitex: 'vítex',
  vitis: 'vítis',
  vitor: 'vítor',
  viuva: 'viúva',
  viuve: 'viúve',
  viuvo: 'viúvo',
  vivio: 'vivió',
  viviu: 'viviú',
  voaco: 'voaço',
  voces: 'vocês',
  voila: 'voilà',
  volei: 'vôlei',
  vomer: 'vômer',
  vouve: 'vouvê',
  vovos: 'vovós',
  vozao: 'vozão',
  xabeu: 'xabéu',
  xamas: 'xamãs',
  xango: 'xangó',
  xaoro: 'xaorô',
  xaras: 'xarás',
  xarem: 'xarém',
  xareu: 'xaréu',
  xenia: 'xênia',
  xenio: 'xênio',
  xenon: 'xênon',
  xerem: 'xerém',
  xerox: 'xérox',
  xexeu: 'xexéu',
  xifio: 'xífio',
  xilon: 'xílon',
  ximao: 'ximão',
  ximbe: 'ximbé',
  xinta: 'xintã',
  xinto: 'xintó',
  xiris: 'xíris',
  xuate: 'xuatê',
  zagao: 'zagão',
  zaibo: 'zãibo',
  zambe: 'zambê',
  zambi: 'zâmbi',
  zarao: 'zarão',
  zeina: 'zeína',
  zifio: 'zífio',
  zinia: 'zínia',
  ziper: 'zíper',
  zizia: 'zízia',
  zuiam: 'zuíam',
  zuias: 'zuías',
  zuido: 'zuído',
  zuira: 'zuíra',
  zuruo: 'zuruó',
}
